import {
  useQuery
} from '@tanstack/vue-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiGetValueAddedServicesParams,
  BackendErrorEntity,
  ValueAddedServiceDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetValueAddedServices = (
    params?: MaybeRef<ApiGetValueAddedServicesParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<ValueAddedServiceDto[]>(
      {url: `/valueAddedServices`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetValueAddedServicesQueryKey = (params?: MaybeRef<ApiGetValueAddedServicesParams>,) => {
    return ['valueAddedServices', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetValueAddedServicesQueryOptions = <TData = Awaited<ReturnType<typeof apiGetValueAddedServices>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetValueAddedServicesParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetValueAddedServices>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetValueAddedServicesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetValueAddedServices>>> = () => apiGetValueAddedServices(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetValueAddedServices>>, TError, TData> 
}

export type ApiGetValueAddedServicesQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetValueAddedServices>>>
export type ApiGetValueAddedServicesQueryError = ErrorType<BackendErrorEntity>



export function useApiGetValueAddedServices<TData = Awaited<ReturnType<typeof apiGetValueAddedServices>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetValueAddedServicesParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetValueAddedServices>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetValueAddedServicesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



